import { Component } from '@angular/core';
import { Fields } from 'src/app/shared/models/candidateprofile-genmodel';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-input-button',
  templateUrl: './input-button.component.html',
  styleUrls: ['./input-button.component.scss'],
  standalone: false,
})
export class InputButtonComponent {
  field: Fields;
  group: UntypedFormGroup;
  constructor() {}

  iseditable() {}
}
